import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { FONTS, COLORS } from "../../constant/";


const styles = StyleSheet.create({
    container: {
        borderRadius: 4,
        height: 18,
        paddingHorizontal: 8, 
        justifyContent:'center',
        alignItems: "center",
    },
    textLabel: {
        fontSize: 9,
        lineHeight: 12,
        fontFamily: FONTS.PM,
    }
});

const statusStyle = {
    container: {
        height: 18,
        backgroundColor: COLORS.white,
    },
    text: {
        fontFamily: FONTS.PSB,
        fontSize: 9,
        lineHeight: 12,
    }
}

const styledStatus = {
    yellow: {
        container: { ...statusStyle.container, backgroundColor: COLORS.yellow },
        text: { ...statusStyle.text, color: COLORS.black900 }
    },
    red: {
        container: { ...statusStyle.container, backgroundColor: COLORS.red },
        text: { ...statusStyle.text, color: COLORS.white }
    },
    active: {
        container: { ...statusStyle.container, backgroundColor: COLORS.green },
        text: { ...statusStyle.text, color: COLORS.white }
    },
    default: {
        container: { paddingHorizontal: 0, },
        text: { ...statusStyle.text, fontFamily: FONTS.PM, color: COLORS.black }
    }
}


const CChip = ({ title, type = "default", style = {} }) => {
    const extStyle = styledStatus[type];
    return (
        <View style={{ ...styles.container, ...extStyle.container, ...style }}>
            <Text style={{ ...styles.textLabel, ...extStyle.text }}>{title}</Text>
        </View>
    )

}

export default CChip;